module.exports = __webpack_public_path__ + "img/icon-yelp.a00d34d3.png";